import { render, staticRenderFns } from "./BuildingForm.vue?vue&type=template&id=2e4592d6&scoped=true"
import script from "./BuildingForm.vue?vue&type=script&lang=js"
export * from "./BuildingForm.vue?vue&type=script&lang=js"
import style0 from "./BuildingForm.vue?vue&type=style&index=0&id=2e4592d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4592d6",
  null
  
)

export default component.exports